$(document).ready(function(){
   function showQuickshop(handle) {
      $.ajax({
        type: 'GET',
        url: '/products/' + handle + '.js',
        dataType: 'json',
        data: handle,
        success: Shopify.onSuccess,
        error: Shopify.onError
      });
   }

   $(".quickshop").click(function(e){
   
      var elem = $(this)
     
      e.preventDefault();
      showQuickshop(elem.attr('data-handle'));
     
   });
  
   Shopify.onSuccess = function(data) {
     //console.log(data);
     //console.log(data.title);
     //console.log($("#quick-shop-title"));
     $("#quick-shop-title").text(data.title);
     
    };
  
    Shopify.onError = function(XMLHttpRequest, textStatus) {
    }
      
});
